module.exports = __webpack_public_path__ + "static/media/bat.8fcb6ba7.gif";